import React from 'react';
import './styles/_fileUpload.scss';
import { CloudUpload, CancelPresentation } from '@material-ui/icons';

const FileUpload = (props) => {
	const { name, onUploadClick, resetData } = props;

	const _getName = (name) => {
		if (!name) return 'Subir Archivo';
		return name.length > 31 ? name.substring(0, 33) + ' ...' : name;
	};

	return (
		<div className="container-file-upload">
			<div className="subcontainer-buttons-file-upload" onClick={onUploadClick}>
				<label className="label-input-file-upload-active">
					<CloudUpload fontSize="large" style={{ color: '#FFFFFF' }} />
				</label>
				<label
					style={{ width: '60%' }}
					className="title-name-file-upload"
					title={name}
				>
					{_getName(name)}
				</label>
				<label className="title-name-file-upload">
					{name && (
						<span onClick={resetData}>
							<CancelPresentation />
						</span>
					)}
				</label>
			</div>
		</div>
	);
};

export default FileUpload;
